import { render, staticRenderFns } from "./sonder.vue?vue&type=template&id=29ab9477&"
import script from "./sonder.vue?vue&type=script&lang=js&"
export * from "./sonder.vue?vue&type=script&lang=js&"
import style0 from "./sonder.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports